import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=12084d9c&scoped=true&"
import script from "./CarouselCard.vue?vue&type=script&lang=js&"
export * from "./CarouselCard.vue?vue&type=script&lang=js&"
import style0 from "./CarouselCard.vue?vue&type=style&index=0&id=12084d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12084d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VImg})
